import { useAuthStore } from "@/store/authStore";
import keycloak from "@/lib/keycloak";

export function useAuth() {
  const { isAuthenticated, isLoading, userRole, username, email, token } =
    useAuthStore();

  function login() {
    if (!keycloak) return;
    keycloak.login({ redirectUri: window.location.href });
  }

  function logout() {
    if (!keycloak) return;
    keycloak.logout({ redirectUri: window.location.origin });
  }

  function loginWithRedirect(redirectPath: string) {
    if (!keycloak) return;
    keycloak.login({ redirectUri: window.location.origin + redirectPath });
  }

  return {
    isAuthenticated,
    isLoading,
    userRole,
    username,
    email,
    token,
    isExpert: userRole === "expert" || userRole === "admin",
    isAdmin: userRole === "admin",
    login,
    logout,
    loginWithRedirect,
  };
}